b
<template>
  <v-card class="card pa-6 mx-auto" elevation="1">
    <div class="px-2 d-flex" style="justify-content: center; text-align: center">
      <h2 class="justify-center">
        <span> Problemas com o pedido? </span>
      </h2>
    </div>

    <div class="my-6 mx-2 px-1 d-flex flex-column justify-center align-center">
      <span class="label py-2">
        Solicite o código de envido de devolução para o cliente pelo e-mail e insira
        abaixo.
      </span>
    </div>
    <div class="my-6 mx-2 px-1 d-flex flex-column justify-center align-center">
      <v-text-field
        outlined
        class="input-modal px-0"
        style="width: 100%"
        color="black"
        background-color="#F5F5F5"
        hide-details
        placeholder="Código de devolução"
        v-model="order.devolvidoCode"
        attach
        @keydown.enter="submit()"
      />
    </div>

    <div>
      <v-row class="d-flex ma-0 pa-0">
        <v-col cols="12" class="d-flex justify-center">
          <v-btn outlined class="cancelBtn mr-2" @click="close" :loading="loading">
            <span class="cancel">Cancelar</span>
          </v-btn>

          <v-btn class="okBtn mr-2" @click="action" :loading="loading">
            <span class="yep">Sim</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style scoped>
.input-modal {
  background: #f5f5f5 !important;
  border: 2px solid #b9b9b9 !important;
  border-radius: 16px !important;
}

.yep {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.15px;

  color: #ffffff;
}
.cancel {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;

  color: #2d3038;
}
.card {
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 11px;
}

.cancelBtn {
  width: 200px !important;
  height: 50px !important;

  border: 2px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 6px;
}

.okBtn {
  width: 200px !important;
  height: 50px !important;

  background: #2d3038 !important;
  border-radius: 6px;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.15px;

  color: #232021;
}

.observation {
  font-family: Roboto;
  font-style: normal;
  color: grey;
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  text-align: justify;
  letter-spacing: 0.15px;

  color: #232021;
}

@media (max-width: 600px) {
  .select-type {
    width: 50% !important;
  }
}

@media (max-width: 600px) {
  .form {
    flex-direction: column;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";

export default {
  name: "AprovalModal",

  props: {
    textObservation: String,
    order: Object,
  },

  data: () => ({
    loading: false,
    excelDialog: "",
    apiService: new ApiService(),
    resale: Object,
  }),

  methods: {
    close() {
      this.$emit("close");
    },

    action() {
      this.$emit("action");
    },
  },
};
</script>
